<template>
    <div class='flex h-full qs-sxpr-so-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
                @toolbar-button-click="onToolbarClickTree"
                @insert-save="insertSave"
                @refresh-end='refreshStoreData'
            >
            </ai-tree-list-edit>
        </div>
        <div class='flex h-full'>
            <ai-grid-edit
                ref='gridRef'
                :meta='gridMeta'
                :args='gridArgs'
                :to-remove-toolbar-items-names='removeGridToolbarBtns'
                @cell-click='onGridCellClick'
                @toolbar-button-click="onToolbarClickGrid"
            ></ai-grid-edit>
        </div>
    </div>
</template>
<script>
export default {
    name: 'qs-sxpr-so-view',
};
</script>
<script setup>
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { computed, onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';

const props = defineProps({
    fromCard: {
        type: Boolean,
        default: () => false,
    },
});

const treeRef = ref();
const gridRef = ref();
const gridArgs = ref();
const keyFocus = ref(null);
const nameBtnclick = ref();
const isNsiChoice = ref(false);
const selectedNsiKod = ref(null);
const selectedNsiGridKod = ref(null);
const defaultSaveArgs = ref({kod_sxp: -1, dep: +getCookie('dep')});


const emits = defineEmits(['choose-nsi']);

onMounted(async () => {
    await onStart();
});

const removeTreeToolbarBtns = computed(() => {
    if (props.fromCard) {
        let arrBtnsTree = removeTreeToolbarBtnsList;
        const removeListAdded = ['addSibling', 'addChild', 'save', 'delete', 'settings'];
        arrBtnsTree = [...arrBtnsTree , ...removeListAdded];
        return arrBtnsTree.filter(item => item !== 'choice' && item !=='export');
    }
    return removeTreeToolbarBtnsList;
});

const removeGridToolbarBtns =  computed(() => {
    if (props.fromCard) {
        let arrBtnsGrid = removeGridToolbarBtnsList;
        const removeListAdded = ['add', 'save', 'delete', 'settings'];
        arrBtnsGrid = [...arrBtnsGrid , ...removeListAdded];
        return arrBtnsGrid;
    }
    return removeGridToolbarBtnsList;
});

const onStart = async (keySelectTree, keySelectGrid) => {
    await treeRef.value?.setDataSource();
    let keySelectTreeFocus = keySelectTree ? keySelectTree : null;
    if(!keySelectTreeFocus) {
        const dataTree = await treeRef.value?.getTreeListDataSource();
        keySelectTreeFocus = dataTree?.length ? dataTree[0].kod_sxp_so : null;
        selectedNsiKod.value = keySelectTreeFocus
    }
    await getGridArgs(keySelectTreeFocus, keySelectGrid);
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);

}

const getGridArgs = (async (key, keySelectGrid) => {
    defaultSaveArgs.value.kod_sxp = key;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    await  setTimeout(async () =>{
        await gridRef.value?.setDataSource();
        let keySelectGridFocus = keySelectGrid ? keySelectGrid : null;
        if(!keySelectGridFocus) {
            const dataGrid = await gridRef.value?.getGridDataSource();
            keySelectGridFocus = dataGrid?.length ? dataGrid[0].kod : null;
            selectedNsiGridKod.value = keySelectGridFocus
        }
        await gridRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    }, 100);
});

const onToolbarClickTree = async (event) => {
    nameBtnclick.value = event?.item?.component?.name;
    if (nameBtnclick.value === 'choice') {
        isNsiChoice.value = true;
        await beforeNsiClose();
    }
};

const beforeNsiClose = async () => {
    const canClose = await treeRef.value?.checkBeforeClose();
    if (!canClose) return false;
    const dataTree = await treeRef.value?.getTreeListDataSource();
    const nsiChoiceItem = await dataTree.find(item => {
        return item.kod_sxp_so === selectedNsiKod.value;
    });
    emits('choose-nsi', nsiChoiceItem, isNsiChoice.value, selectedNsiGridKod.value);
};

const onTreeCellClick = async (event) => {
    selectedNsiKod.value = event.key;
    const check = await checkGrid();
    if(!check) return;
    if(event.key !== defaultSaveArgs.value.kod_sxp) {
        await getGridArgs(event.key);
    }
};

const onGridCellClick = async (viewId, key) => {
    selectedNsiGridKod.value = key;
};

const insertSave = async (insert) => {
    if(insert?.responses?.length) {
        keyFocus.value = insert?.responses[0]?.id;
    }
}

const refreshStoreData = async () => {
    if( nameBtnclick.value === 'save' && keyFocus.value) {
        await getGridArgs(keyFocus.value);
        await treeRef.value?.treeListInstance.option('focusedRowKey',keyFocus.value);
        keyFocus.value = null;
        nameBtnclick.value = '';
    } else if (nameBtnclick.value === 'delete' || nameBtnclick.value === 'refresh') {
        const dataTree = await treeRef.value?.getTreeListDataSource();
        const keyFirst = dataTree?.length ? dataTree[0].kod_sxp_so : null;
        await getGridArgs(keyFirst);
        await treeRef.value?.treeListInstance.option('focusedRowKey', keyFirst);
        keyFocus.value = null;
        nameBtnclick.value = '';
    }
}

const checkGrid = async () => {
    await gridRef.value.gridInstance.clearSelection();
    const canClose = await gridRef.value?.checkBeforeClose();
    return canClose;
};

defineExpose({
    beforeNsiClose: beforeNsiClose,
    onStart: (keySelect = null) => onStart(keySelect),
});

const removeTreeToolbarBtnsList = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];

const removeGridToolbarBtnsList = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy'];

const treeMeta = {
    "keyExpr": "kod_sxp_so",
    rights: {IDU: !props.fromCard},
    "columns": [
        {
            "name": "kod_sxp_so",
            "caption": "kod_sxp_so",
            "dataField": "kod_sxp_so",
            "allowEditing": false,
            "width": 250,
            "index": 1,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Название",
            "dataField": "name",
            "allowEditing": true,
            "width": '100%',
            "visible": true
        },
        {
            "name": "kod_r",
            "caption": "kod_r",
            "dataField": "kod_r",
            "allowEditing": false,
            "width": 250,
            "index": 3,
            "visible": false
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "allowEditing": false,
            'width': 30,
            'minWidth': 30,
            "index": 5,
            "visible": true
        }
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/qs-sxpr-so-tree/select/get",
        "save": "tep-nsi./tep-nsi/qs-sxpr-so-tree/save/set"
    },
    "viewId": "view-qs-sxpr-so-tree",
    "id": "qs-sxpr-so",
    "parentIdExpr": "kod_r",
    'findTool': 'filter',
    'selectButtonMode': 'single',
    'selectionMode': 'single',
    'maxWidth': 'w-full',
    'wordWrapEnabled': true,
    'allowColumnResizing': false,
};

const gridMeta =  {
    'keyExpr': 'kod',
    rights: {IDU: !props.fromCard},
    'selectionMode': props.fromCard ? 'single' : 'multiple',
    'columns': [
        {
            'name': 'kod',
            'caption': 'kod',
            'dataField': 'kod',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kod_sxp',
            'caption': 'kod_sxp',
            'dataField': 'kod_sxp',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'kod_pk',
            'caption': 'Темп. граф. ПК [°C]',
            'dataField': 'kod_pk',
            'allowEditing': true,
            'width': '50%',
            'index': 10,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_pk"
            },
            "component": {
                "name": "lookup-qs-sxpr-pk",
                "id": "kod",
                "text": "name",
                "minHeight": '200px'
            }
        },
        {
            'name': 'kod_sk',
            'caption': 'Темп. граф. СК [°C]',
            'dataField': 'kod_sk',
            'allowEditing': true,
            'width': '50%',
            'index': 9,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_sk"
            },
            "component": {
                "name": "lookup-qs-sxpr-sk",
                "id": "kod",
                "text": "name",
                "minHeight": '200px'
            }
        },
    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/qs-sxpr-so-grid/select/get',
        'save': 'tep-nsi./tep-nsi/qs-sxpr-so-grid/save/set',
    },
    'viewId': 'view-qs-sxpr-so-grid',
    "id": "qs-sxpr-so",
    };
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 400px;
}
</style>
